// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3Mk4m","infoBtn":"quickbooks_infoBtn__1Vm4L","formBox":"quickbooks_formBox__2z8Vg","formFooter":"quickbooks_formFooter__1lwdQ"};